import { theme } from "themes/default/theme"
import "@reactour/popover/dist/index.css"

const popoverRadius = 5
const margin = 5

const opositeSide = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right",
}

export function doArrow(position, verticalAlign, horizontalAlign) {
  if (!position || position === "custom") {
    return {}
  }

  const width = 14
  const height = 7
  const color = "white"
  const isVertical = position === "top" || position === "bottom"
  const spaceFromSide = 10

  const obj = {
    [`--rtp-arrow-${
      isVertical ? opositeSide[horizontalAlign] : verticalAlign
    }`]: height + spaceFromSide + "px",
    [`--rtp-arrow-${opositeSide[position]}`]: -height + 2 + "px",
    [`--rtp-arrow-border-${isVertical ? "left" : "top"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${isVertical ? "right" : "bottom"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${position}`]: `${height}px solid ${color}`,
  }
  return obj
}

export const popoverStyles = {
  popover: (base, state) => ({
    ...base,
    "--reactour-accent": theme.palette.primary.main,
    minWidth: 295,
    maxWidth: 320,
    [`--base-test`]: JSON.stringify(base),
    [`--base-state`]: JSON.stringify(state),
    // width: `calc(100% - 200px)`,
    borderRadius: popoverRadius,
    margin: margin,
    padding: 15,
    color: "#2d2d2d",
    boxShadow: "0 1px 10px #0006",
    // paddingLeft: 22,
    // paddingRight: 22,
    // paddingTop: 18,
    // paddingBottom: 18,
    marginTop:
      state.position === "bottom"
        ? 10
        : state.position === "top"
        ? -10
        : margin,
    marginLeft:
      state.position === "right"
        ? 10
        : state.position === "left"
        ? -10
        : margin,
    ...doArrow(state.position, state.verticalAlign, state.horizontalAlign),
    // marginBottom: -30,
    ...(state.position === "top" && {
      top: -25,
    }),
  }),
}
